import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import DisclaimerPage from './DisclaimerPage';
import SocialReportingGuide from './SocialReportingGuide';
import SupportResources from './SupportResources';

const { FiHeart, FiLifeBuoy, FiShield } = FiIcons;

function GuidelinesPage() {
  const guidelines = [
    ['Protect privacy', 'Do not share names, addresses, contact details, or other identifying information.'],
    ['Report, do not retaliate', 'Use the platform’s official tools. Do not threaten, harass, or contact people involved.'],
    ['Share responsibly', 'Submit a public link and a brief, factual description. Avoid repeating harmful language.'],
    ['Respect the community', 'Help keep this space calm, respectful, and focused on safety.']
  ];

  return (
    <section>
      <div className="page-intro">
        <span className="eyebrow">Community safety</span>
        <h1>Community guidelines</h1>
        <p>Help keep this space calm, respectful, and focused on safety.</p>
      </div>
      <div className="guideline-list">
        {guidelines.map(([title, description], index) => (
          <article className="guideline-item" key={title}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <div>
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
          </article>
        ))}
      </div>
      <SocialReportingGuide />
    </section>
  );
}

function CaseDetail({ cases, onView, visitKey }) {
  const [searchParams] = useSearchParams();
  const viewedKey = useRef('');
  const id = searchParams.get('id');
  const item = cases.find((entry) => String(entry.id) === id);

  useEffect(() => {
    if (!item || !onView) return;
    const key = `${id}:${visitKey}`;
    if (viewedKey.current === key) return;
    viewedKey.current = key;
    onView(id);
  }, [id, item, onView, visitKey]);

  if (!item) return <div className="empty-state">This case could not be found.</div>;

  return (
    <section className="detail-card section-card">
      <span className="eyebrow">Community case</span>
      <h1>{item.platform} · {item.category}</h1>
      <p className="case-description">{item.description}</p>
      <p className="empty-copy">
        {Number(item.views || 0)} views · {Number(item.reports || 0)} reports
      </p>
      <a className="button button-secondary" href={item.link} target="_blank" rel="noreferrer">
        Open original post
      </a>
    </section>
  );
}

function ExtraPages({ page, cases = [], onView, visitKey }) {
  if (page === 'Support') return <SupportResources />;
  if (page === 'Guidelines') return <GuidelinesPage />;
  if (page === 'Disclaimer') return <DisclaimerPage />;
  if (page === 'Case Detail') {
    return <CaseDetail cases={cases} onView={onView} visitKey={visitKey} />;
  }
  return null;
}

export default ExtraPages;